<template>

    <div class="layout__padding-clear">
        <div class="colour__background-teal layout__overflow-hidden text__colour-white text__align-center">

            <!--<div class="">-->
            <h2 class="layout__padding__top-50px">Marketing Toolkit</h2>
            <h3 class="layout__padding-20-0 text__colour-white layout__padding-clear layout__width-20">Our
                all-in-one marketing <br>and print platform</h3>


            <div class="">
                <div class="layout__padding-clear layout__width-40 text__align-center">
                    <a href="https://ravensworth.co.uk/our-tech/toolkit/" target="_blank">
                        <el-button
                                class="button-white-grey button__base__header-large layout__width-250px layout__margin__top-20 text__colour-white layout__margin__right-20px"
                                v-on:click="activeUploadDialogue = true">Want to know more?
                        </el-button>
                    </a>

                    <router-link to="/contact">
                        <el-button
                                class="button-white-grey button__base__header-large layout__width-250px layout__margin__top-20 text__colour-white layout__margin__right-20px"
                        >
                            Need more info?
                        </el-button>
                    </router-link>

                    <a href="https://marketingtoolkit.ravensworth.co.uk/" target="_blank">
                        <el-button
                                class="button-white-grey button__base__header-large layout__width-250px layout__margin__top-20 text__colour-white layout__margin__right-20px"
                                v-on:click="activeUploadDialogue = true">Login
                        </el-button>
                    </a>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-50 layout__padding-20px text__colour-white">
                <div class="layout__padding-40px-0 layout__padding-clear layout__width-100">
                    <div class="component__columns-2">
                        <img class="layout__width-100 layout__position-right" src="https://rpsassets.blob.core.windows.net/rpsimages/images/toolkit/Run-like-clockwork.png">
                    </div>
                    <div class="component__columns-2 layout__padding-20-0">
                        <p class="text__size-20 text__colour-white">Smarter Marketing</p>

                        <p class="text__colour-white layout__padding-20-0 text__style-bold-900 text__size-16">Run like clockwork with a system that
                            saves you time and effort.</p>
                        <p class="text__colour-white text__size-16">Marketing Toolkit lets you take control of your
                            orders, budgets & reporting, streamlining all
                            your marketing output into one convenient
                            system. Not only that, but it helps you unify
                            your brand style, guaranteeing one consistent
                            message across every branch.</p>

                    </div>
                </div>
                <div class="layout__padding-40px-0 layout__padding-clear layout__width-100">
                    <div class="component__columns-2 layout__padding-20-0">
                        <p class="text__size-20 text__colour-white">Built for your needs</p>

                        <p class="text__colour-white layout__padding-20-0 text__style-bold-900 text__size-16">Marketing Toolkit is the only web‑to‑print
                            platform
                            specifically designed for the property industry.</p>
                        <p class="text__colour-white text__size-16">It’s been built by the industry’s leading print
                            marketing supplier, using 17 years of experience
                            and feedback from property professionals. It uses
                            templated designs based on tried and tested
                            formats to simplify the process of design and
                            printing marketing materials for your agency.</p>
                    </div>
                    <div class="component__columns-2">
                        <img class="layout__width-100 layout__position-right" src="https://rpsassets.blob.core.windows.net/rpsimages/images/toolkit/Built-for-needs.png">
                    </div>
                </div>
                <div class="layout__padding-40px-0 layout__padding-clear layout__width-100">
                    <div class="component__columns-2">
                        <img class="layout__width-100 layout__position-right" src="https://rpsassets.blob.core.windows.net/rpsimages/images/toolkit/Takecontrol2.png">
                    </div>
                    <div class="component__columns-2 layout__padding-20-0">
                        <p class="text__size-20 text__colour-white">You’re in control</p>

                        <p class="text__colour-white layout__padding-20-0 text__style-bold-900 text__size-16">Marketing Toolkit puts the control
                            back in your hands.</p>
                        <p class="text__colour-white text__size-16">Create templates and image assets for every stage
                            of the journey. Alter what you need to and send it
                            straight to print. No more emailing back and
                            forward, you’re in the driving seat.</p>

                    </div>
                </div>
                <div class="layout__padding-40px-0 layout__padding-clear layout__width-100">
                    <div class="component__columns-2 layout__padding-20-0">
                        <p class="text__size-20 text__colour-white">Order from anywhere</p>

                        <p class="text__colour-white layout__padding-20-0 text__style-bold-900 text__size-16">Do your marketing on the go so you never miss
                            an
                            opportunity.</p>
                        <p class="text__colour-white text__size-16">The web based platform means you can log in and
                            place your order whenever and wherever you are.</p>
                    </div>
                    <div class="component__columns-2">
                        <img class="layout__width-100 layout__position-right" src="https://rpsassets.blob.core.windows.net/rpsimages/images/toolkit/Order-Anywhere.png">
                    </div>
                </div>
            </div>
            <!--</div>-->

            <div class="layout__padding-clear layout__width-40 text__align-center">
                <div class="layout__margin__top__bottom-60">
                    <a href="https://ravensworth.co.uk/our-tech/toolkit/" target="_blank">
                        <el-button
                                class="button-white-grey button__base__header-large layout__width-250px layout__margin__top-20 text__colour-white layout__margin__right-20px"
                                v-on:click="activeUploadDialogue = true">Want to know more?
                        </el-button>
                    </a>

                    <router-link to="/contact">
                        <el-button
                          class="button-white-grey button__base__header-large layout__width-250px layout__margin__top-20 text__colour-white layout__margin__right-20px"
                        >
                            Need more info?
                        </el-button>
                    </router-link>

                    <a href="https://marketingtoolkit.ravensworth.co.uk/" target="_blank">
                        <el-button
                                class="button-white-grey button__base__header-large layout__width-250px layout__margin__top-20 text__colour-white layout__margin__right-20px"
                                v-on:click="activeUploadDialogue = true">Login
                        </el-button>
                    </a>
                </div>
            </div>


        </div>

    </div>

</template>

<script>
    import Vue from 'vue';
    import Axios from 'axios';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';

    Vue.use(Element);

    export default {
        name: "marketingToolkitLanding",
        mixins: [
            axios
        ],
        data() {
            return {
            }

        },
        created() {
            console.log('marketing toolkit landing')
            console.log(this.returnHeaderUsingToken())

        },
        methods: {
        }
    };
</script>